import { CanvasTexture, SRGBColorSpace } from 'three';

/** A texture drawn in code: logos, banners, the ring's print. No image files to load. */
export function drawnTexture(width: number, height: number, draw: (g: CanvasRenderingContext2D, w: number, h: number) => void): CanvasTexture {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  draw(canvas.getContext('2d')!, width, height);
  const texture = new CanvasTexture(canvas);
  texture.colorSpace = SRGBColorSpace;
  texture.anisotropy = 8;
  return texture;
}
